import { Component, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-followup-questionnaire',
  styleUrls: ['./followup-questionnaire-modal.component.scss',],
  template: `
    <div class="modal-header">
      <h5 class="modal-title text-center"><em i18n>Cuestionario enviado.</em></h5>
    </div>
    <div class="modal-body">
      <p i18n>Se envío correctamente el cuestionario.</p>
      <p i18n>Hemos enviado un correo electrónico con una invitación para responder al cuestionario.</p>
      <p class="mt-3" i18n>Dejamos a tu disposición el link por si gustas compartirlo a tu cliente para agilizar su proceso</p>
      <p class="text-uppercase"><small i18n>(click en enlace para copiar a portapaleles)</small></p>
      <div class="mt-3">
        <input type="text" class="form-control cursor-pointer border "
          (click)="this.copyToClipboard()"
          [value]="this.protocolLink" [readOnly]=true>
      </div>
      <div class="modal-footer">
        <button class="btn btn-danger mx-auto" (click)="this.close()" i18n>Cerrar</button>
      </div>
    </div>
  `
})
export class FollowupQuestionnaireModalComponent  {
  @Input() protocolLink: string;
  
  constructor(protected bsModalRef: BsModalRef,
              protected toastr:ToastrService) { }
  
  close() { this.bsModalRef.hide(); }
  copyToClipboard() {
    navigator.clipboard.writeText(this.protocolLink);
    console.log(this.protocolLink)
    this.toastr.success($localize`Enlace copiado a portapapeles`)
  }
}
